<template>
  <v-dialog :value="value" max-width="960" persistent @input="$emit('input', $event)">
    <div class="novidades-pdf-preview">
      <div class="novidades-pdf-preview__header">
        <div class="d-flex align-center" style="gap: 8px;">
          <v-icon x-small color="#059669">fas fa-file-download</v-icon>
          <span class="novidades-pdf-preview__title">{{ title }}</span>
        </div>
        <div class="d-flex align-center" style="gap: 8px;">
          <button
            type="button"
            class="novidades-pdf-preview__download"
            @click="download"
          >
            <v-icon x-small class="mr-1">fas fa-download</v-icon>
            Baixar PDF
          </button>
          <button type="button" class="novidades-pdf-preview__close" @click="close">
            <v-icon x-small>fas fa-times</v-icon>
          </button>
        </div>
      </div>
      <div class="novidades-pdf-preview__frame-wrap">
        <iframe v-if="objectUrl" :src="objectUrl" title="Pré-visualização PDF" />
        <div v-else class="novidades-pdf-preview__empty">Carregando PDF...</div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "PdfPreviewModal",
  props: {
    value: { type: Boolean, default: false },
    blob: { type: Blob, default: null },
    filename: { type: String, default: "novidades.pdf" },
    title: {
      type: String,
      default: "Pré-visualização do Relatório em PDF (A4)"
    }
  },
  data: () => ({
    objectUrl: null
  }),
  watch: {
    blob: {
      immediate: true,
      handler(blob) {
        this.revokeUrl();
        if (blob) {
          this.objectUrl = URL.createObjectURL(blob);
        } else {
          this.objectUrl = null;
        }
      }
    },
    value(open) {
      if (!open) {
        this.revokeUrl();
      }
    }
  },
  beforeDestroy() {
    this.revokeUrl();
  },
  methods: {
    revokeUrl() {
      if (this.objectUrl) {
        URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = null;
      }
    },
    close() {
      this.$emit("input", false);
      this.$emit("close");
    },
    download() {
      if (!this.blob) return;
      const url = URL.createObjectURL(this.blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = this.filename || "novidades.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.novidades-pdf-preview {
  background: var(--np-surface, #fff);
  border-radius: 16px;
  overflow: hidden;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid var(--np-border, #e2e8f0);
    background: var(--np-surface-muted, #f8fafc);
  }

  &__title {
    font-size: 12px;
    font-weight: 700;
    color: var(--np-text, #0f172a);
  }

  &__download {
    border: none;
    background: #059669;
    color: #fff;
    padding: 8px 14px;
    border-radius: 10px;
    font-size: 11px;
    font-weight: 700;
    cursor: pointer;
    display: inline-flex;
    align-items: center;

    .v-icon {
      color: #fff !important;
    }
  }

  &__close {
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 6px;
    color: #64748b;
  }

  &__frame-wrap {
    height: 75vh;
    background: #e2e8f0;

    iframe {
      width: 100%;
      height: 100%;
      border: 0;
      background: #fff;
    }
  }

  &__empty {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
    font-size: 13px;
  }
}
</style>
